module.exports = __webpack_public_path__ + "static/media/pagenotfound.b02b7b45.jpg";